<template>
  <section class="section process">
    <!-- Table -->
    <table-ag
      :if="processes"
      :rowData="processes"
      :columnDefs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      :typeSelection="'single'"
      @selected="selected"
    ></table-ag>

    <!-- Components -->
    <transition name="slide-custom">
      <MenuCreateProcess
        v-if="showMenuCreate"
        type="lid"
        :data="processEdit"
        :hasBenchmark="hasBenchmark"
        @closeMenuCreate="closeMenuCreate"
        @getProcesses="getProcesses"
      >
      </MenuCreateProcess>
    </transition>
    <ModalConsolidado
      :show="showModalCon"
      :listProcesses="processes"
      @closeModal="closeModal"
      @getProcesses="getProcesses"
    ></ModalConsolidado>
    <ModalComparacion
      ref="modalCompLider"
      :show="showModalCom"
      :process="process"
      :listProcesses="processes"
      @closeModalComp="closeModalComp"
      @getProcesses="getProcesses"
      @selected="selected"
      @deleteComparison="deleteComparison"
    ></ModalComparacion>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
import tableAg from "../dashboard/tableAg.vue";
import menuTableProcess from "./components/menuTableProcess.vue";
import buttonsActionProcess from "./components/buttonsActionProcess.vue";
import ModalConsolidado from "../modals/ModalConsolidado";
import ModalComparacion from "../modals/ModalComparacion.vue";
import MenuCreateProcess from "./components/menuCreateProcess.vue";
export default {
  data() {
    return {
      processes: [],
      process: {},
      processEdit: {},
      columns: [
        {
          field: "nombre",
          headerName: "Proceso",
          editable: false,
          cellRenderer: (params) => {
            return `${this.formatTypeProcess(params)} ${params.value}`;
          },
        },
        {
          field: "comparison",
          headerName: "Comparación",
          cellRenderer: (params) => {
            return this.formatStatusComp(params.value);
          },
          editable: false,
          width: 60,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          tooltipValueGetter: (params) => {
            return params.value ? params.value.nombre : null;
          },
        },
        {
          field: "created",
          headerName: "Creado",
          editable: false,
          cellRenderer: (params) => {
            return this.dateProcess(params.value);
          },
          width: 60,
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "_id",
          headerName: "Controles",
          colId: "_actions",
          editable: false,
          width: 80,
          cellRenderer: "ButtonsActionProcessLid",
          hide: this.tokenUser ? this.tokenUser["ghumana"] : true,
        },
      ],
      components: {
        ButtonsActionProcessLid: () => {
          return {
            render: (h) =>
              h(buttonsActionProcess, {
                props: {},
                on: {
                  editProcess: this.editProcess,
                  selectedComp: this.selectedComp,
                },
              }),
          };
        },
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableProcess, {
              props: {},
              on: {
                closeMenuCreate: this.closeMenuCreate,
                closeModalCon: this.closeModal,
              },
            }),
        };
      },
      showModalCon: false,
      showModalCom: false,
      showMenuCreate: false,
    };
  },
  props: {
    tokenUser: Object,
  },
  computed: {
    ...mapState(["idtoken"]),
    hasBenchmark() {
      return this.processes.some((x) => x.benchmark === 1);
    },
  },
  beforeMount() {},
  created() {
    if (this.idtoken) {
      this.getProcesses();
    }
  },
  methods: {
    // Table
    async getProcesses() {
      try {
        const result = await apiServices.get(`/listliderprocesos`);
        if (result.data) {
          this.processes = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async selected(pro1, pro2) {
      if (pro2) {
        const newProcess = this.orderProcessSelection([pro1, pro2]);
        const result = await apiServices.post("saveCompProcessLider", {
          idProcess: newProcess[0]._id,
          idProcessComp: newProcess[1]._id,
        });

        if (result.data) {
          await this.$swal({
            html:
              "Comparación guardada correctamente. <br><br> Al proceso" +
              ` <span class="has-text-weight-bold">${newProcess[0].nombre}</span> ` +
              "se le asignó la comparación.",
            icon: "success",
          });
          pro1 = newProcess[0];
          pro2 = newProcess[1];
        } else {
          await this.$swal({
            text: "Error al guardar y comparar los dos procesos.",
            icon: "error",
          });
        }
      } else {
        if (pro1.comparison) {
          pro2 = pro1.comparison;
        } else {
          pro2 = {};
        }
      }
      this.$emit("selproceso", pro1, pro2);
    },
    selectedComp(proc) {
      this.process = proc;
      this.closeModalComp();
    },
    // Modals or Components
    closeModal() {
      this.showModalCon = !this.showModalCon;
    },
    closeModalComp() {
      this.showModalCom = !this.showModalCom;
    },
    closeMenuCreate() {
      this.showMenuCreate = !this.showMenuCreate;
      if (!this.showMenuCreate) this.processEdit = {};
    },
    async deleteComparison(id) {
      try {
        const result = await apiServices.delete(`procesoComp/${id}`);
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: `Se elimino correctamente.`,
            type: "is-link",
          });
          await this.getProcesses();
          this.$refs.modalCompLider.close();
        }
      } catch (error) {
        await this.$store.dispatch("notify", {
          message: `No se elimino correctamente la comparación.`,
          type: "is-danger",
        });
      }
    },
    editProcess(data) {
      this.processEdit = data;
      this.closeMenuCreate();
    },
    // Helpers
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "numeric", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    formatTypeProcess(p) {
      if (!p.data.benchmark) return "";
      return `<span class="tag tag-process is-success is-capitalized"><i class="mdi mdi-${
        p.data.benchmark === 2
          ? "account-star-outline"
          : "database-import-outline"
      }"></i></span>`;
    },
    formatStatusComp(v) {
      if (v) {
        return `<span class="tag is-dark is-capitalized">Sí</span>`;
      } else {
        return `<span class="tag is-warning is-capitalized">No</span>`;
      }
    },
    orderProcessSelection(p) {
      return p.sort(
        (objA, objB) =>
          Number(new Date(objB.created)) - Number(new Date(objA.created)),
      );
    },
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.getProcesses();
      }
    },
  },
  components: {
    tableAg,
    ModalConsolidado,
    ModalComparacion,
    MenuCreateProcess,
  },
};
</script>
<style lang="scss">
.ag-pre-table .ag-header-cell-label {
  justify-content: center !important;
}
.slide-custom-enter {
  transform: translateX(30vw);
}

.slide-custom-enter-active {
  transition: all 0.3s ease-in;
}

.slide-custom-leave-active {
  transition: all 0.3s ease-in;
}
.slide-custom-leave-to {
  transform: translateX(30vw);
}

.slide-custom-two-enter {
  transform: translateX(30vw);
}

.slide-custom-two-enter-active {
  transition: all 0.3s ease-in;
}

.slide-custom-two-leave-active {
  transition: all 0.3s ease-in;
}
.slide-custom-two-leave-to {
  transform: translateX(30vw);
}

.process .tag-process {
  margin-right: 5px;
  height: auto !important;
  font-size: 17px !important;
  padding-left: 0.35em !important;
  padding-right: 0.35em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Proceso.vue